export interface LoginRequest {
  userId: string
  password: string
  branchCode: string
  placeCode: string
  authKey: string
  _forceLogin: boolean
}

export function LoginRequestToJSON(value: LoginRequest): any {
  return {
    user_id: value.userId,
    password: value.password,
    branch_code: value.branchCode,
    place_code: value.placeCode,
    auth_key: value.authKey,
    _force_login: value._forceLogin
  }
}
